import React, { useEffect, useState } from 'react'
import { useDashboardContext } from '../../../../contexts/NewDashboardContext';
import { alertV2 } from '../../../../api';
import { Card, CardBody } from "../../../../components/card/card";

export const AverageResolutionTime = ({}) => {
  const { dateRangeOverview } = useDashboardContext();
  const [averageResolutionTime, setAverageResolutionTime] = useState(0);
  const [totalAlarms, setTotalAlarms] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  // Get theme colors from CSS variables
  const getThemeColors = () => {
    const bodyBg = getComputedStyle(document.body)
      .getPropertyValue("--bs-body-bg")
      .trim();
    const textColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-body-color")
      .trim();
    const gridColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-border-color")
      .trim();
    const themeColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme")
      .trim();

    return { bodyBg, textColor, gridColor, themeColor };
  };

  const { bodyBg, textColor, gridColor, themeColor } = getThemeColors();

  async function getData() {
    try {
      const result = await alertV2.listByDate({
        start_date: dateRangeOverview?.startDate,
        end_date: dateRangeOverview?.endDate,
        status: "Closed",
      });
      const body = await result.json();

      // Process the data
      processData(body.data);
    } catch (error) {
      console.error("Error fetching alarm data:", error);
      // Use mock data for demonstration
      createMockData();
    } finally {
      setIsLoading(false);
    }
  }

  const processData = (apiData) => {
    if (!apiData || !Array.isArray(apiData)) {
      console.log("No valid API data, using mock data");
      createMockData();
      return;
    }

    // Calculate resolution times for closed alarms
    const resolutionTimes = [];

    apiData.forEach((alert) => {
      // Process alarms that have both max_date and updated_at
      if (
        alert.max_date &&
        alert.updated_at &&
        alert.alertlogs &&
        alert.alertlogs.length > 0
      ) {
        const alertlog = alert.alertlogs[0];
        const maxDate = new Date(alert.max_date);
        const updatedDate = new Date(alertlog.event_date);

        // Calculate difference in days
        const timeDifference = updatedDate.getTime() - maxDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        // Only include if resolution time is positive
        if (daysDifference > 0) {
          resolutionTimes.push(daysDifference);
        }
      }
    });

    console.log("Resolution times:", resolutionTimes);

    // If no valid resolution times, use mock data
    if (resolutionTimes.length === 0) {
      console.log("No valid resolution times found, using mock data");
      createMockData();
      return;
    }

    // Calculate average resolution time
    const totalDays = resolutionTimes.reduce((sum, days) => sum + days, 0);
    const avgResolutionTime = Math.round(totalDays / resolutionTimes.length);
    const totalCount = resolutionTimes.length;

    setAverageResolutionTime(avgResolutionTime);
    setTotalAlarms(totalCount);
  };

  const createMockData = () => {
    // Mock data matching the image
    setAverageResolutionTime(0);
    setTotalAlarms(0);
  };

  useEffect(() => {
    getData();
  }, [dateRangeOverview]);

  // If loading, show spinner
  if (isLoading) {
    return (
      <div
        style={{
          height: "370px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: bodyBg,
          borderRadius: "8px",
          border: `1px solid ${gridColor}`,
        }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Card>
      <CardBody>
        <div
          style={{
            position: "relative",
            height: "370px",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "20px",

            padding: "20px",
          }}
        >
          {/* Title */}
          <div
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: textColor,
              marginBottom: "30px",
              textAlign: "center",
            }}
          >
            Average Resolution Time
          </div>

          {/* Circle */}
          <div
            style={{
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              border: "1px solid #000",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#000",
                marginBottom: "5px",
              }}
            >
              {averageResolutionTime} Days
            </div>
          </div>

          {/* Total Alarm Count */}
          <div
            style={{
              fontSize: "14px",
              color: textColor,
              textAlign: "center",
              fontWeight: "500",
            }}
          >
            Total Alarm: {totalAlarms}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
